/**
 * SplashLogo component.
 */
import FlavourConfig from '@shared/config/flavours';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled splash logo.
 */
const SplashLogo = styled.img<React.CSSProperties>`
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  width: ${FlavourConfig.sizes.splashLogo * Screen.widthRatio}px;
`;

/**
 * Default props for splash logo.
 */
SplashLogo.defaultProps = {
  src: FlavourConfig.images.logo,
};

export default withOpacity(SplashLogo);
